import React, { useState } from "react";
import { BCNewOrderLine, BCNewOrderRequest } from "../../../Interfaces/BCNewOrderRequest";
import { Button, Card, List } from "antd";
import {
    CloseOutlined, ArrowLeftOutlined
} from "@ant-design/icons";
import PageHeaderAstena from "../../../Components/PageHeaderAstena";
import Title from "antd/es/typography/Title";
import AddServiceItemModal from "./AddServiceItemModal";
import { DataService } from "../../../Services/DataService";

type Props = {
    onExit: () => void;
    onFinish: (request: BCNewOrderLine[]) => void;
    onBack: () => void;
    loading: boolean;
    request: BCNewOrderRequest | undefined;
}

const NewServiceOrderService = (props: Props) => {

    const [lines, setLines] = useState<BCNewOrderLine[]>([]);
    const [modalOpen, setModalOpen] = useState(false);


    function onFinishModal(line: BCNewOrderLine) {
        let help = [...lines];
        help.push(line);
        setLines(help);
        setModalOpen(false);
    }

    function onDeleteItem(item: BCNewOrderLine) {
        let help = [...lines];
        if (item.serviceItemNo)
            help = help.filter(x => x.serviceItemNo != item.serviceItemNo);
        else
            if (item.serialNo && item.serialNo != "")
                help = help.filter(x => x.serialNo != item.serialNo);
            else help = help.filter(x => x.itemNo != item.itemNo);
        setLines(help);
    }

    function onFinishRequest() {
        props.onFinish(lines);
    }

    return (
        <Card
            className="service-card"
            style={{ minWidth: 400, flex: 0.5 }}
            title={(
                <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", color: "white" }}>
                    <div style={{ display: "flex", flexDirection: "row" }}>
                        <ArrowLeftOutlined onClick={props.onBack} style={{ marginRight: 16 }} />
                        <span >Nieuw serviceorder</span>
                    </div>
                    <CloseOutlined onClick={props.onExit} />
                </div>
            )}
        >
            {modalOpen && props.request && (
                <AddServiceItemModal isOpen={modalOpen} onCancel={() => setModalOpen(false)} onOk={onFinishModal} request={props.request} />
            )}
            <PageHeaderAstena
                style={{ padding: 0, margin: 0, marginBottom: 16 }}
                title={
                    <div style={{ fontWeight: "bold", fontSize: 16, color: "#69ACFD" }}>
                        {`Service artikels`}
                    </div>
                }
                extra={[
                    <Button
                        key={1} type="text" style={{ color: "#EF8421", fontWeight: "600" }}
                        onClick={() => { setModalOpen(true) }}>{"+ Artikel toevoegen"}
                    </Button>
                ]}
            />
            <List
                pagination={{
                    pageSize: 8
                }}
                locale={{ emptyText: "Geen artikelen" }}
                dataSource={lines}
                renderItem={(item) => (
                    <Card
                        style={{ boxShadow: "rgba(149, 157, 165, 0.1) 0px 8px 24px" }}
                        bodyStyle={{ margin: 0, padding: 8 }}
                    >
                        <span style={{ display: "flex", flexDirection: "column" }}>
                            <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", marginBottom: 4 }}>
                                <span style={{ color: "#959595", fontSize: 10 }}>{item.serviceItemNo}</span>
                                <CloseOutlined style={{ color: "red" }} onClick={() => onDeleteItem(item)} />
                            </div>
                            <span style={{ color: "#69ACFD", fontSize: 14 }}>{item.description}</span>
                            <span style={{ fontSize: 12 }}>Serienummer: {item.serialNo}</span>
                        </span>
                    </Card>
                )}
            />
            <Button
                loading={props.loading}
                size="large"
                type="primary"
                style={{ backgroundColor: "#1C253B", boxShadow: "none", width: "100%", marginTop: 24 }}
                className="astena-btn"
                onClick={onFinishRequest}
            >
                {"Versturen"}
            </Button>
        </Card>

    );
};

export default NewServiceOrderService;